import { defineMessages } from 'react-intl';

export default defineMessages({
    productOffering:{
        id: 'premier.policyjob.views.product.offerings',
        defaultMessage: 'Offerings'
    },
    productOfferingSelection:{
        id: 'premier.policyjob.views.product.offerings.label',
        defaultMessage: 'Offering Selection'
    }
});